/**
 * AnalystBro Quantitative Research & Market Intelligence Blog Posts
 * 
 * To publish a new blog post, add an object to the BLOG_POSTS array below.
 * Example schema:
 * {
 *   id: "my-post-slug",
 *   slug: "my-post-slug",
 *   title: "Your Post Title",
 *   subtitle: "A short descriptive subtitle",
 *   date: "October 4, 2026",
 *   publishDate: "2026-10-04",
 *   author: {
 *     name: "Author Name",
 *     role: "Title / Role",
 *     avatar: "https://url-to-avatar.png",
 *   },
 *   category: "Quantitative Methods", // or any category
 *   readTime: "5 min read",
 *   badge: "Market Research",
 *   featured: false,
 *   summary: "Short 2-line summary displayed on cards",
 *   tags: ["Backtesting", "Equities"],
 *   keyTakeaways: [
 *     "Takeaway point 1",
 *     "Takeaway point 2",
 *   ],
 *   content: `Markdown content here...`
 * }
 */

export const BLOG_POSTS = [];

export const BLOG_CATEGORIES = [
  "All",
  "AI & Fundamental Research",
  "Quantitative Methods",
];

export function getBlogPost(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug);
}
